import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { SettingsPaymentDepositAccountContainer } from "@/components/features/settings/payment-deposit-account";

import { useConfirmParams } from "./hooks";

export const SettingsPaymentDepositAccountPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="入金先情報の設定" url={generatePath(PATHS.SETTINGS.PAYMENT_DEPOSIT_ACCOUNT, { hotelID })}>
			<SettingsPaymentDepositAccountContainer hotelID={hotelID} />
		</PageMeta>
	);
};

SettingsPaymentDepositAccountPage.displayName = "SettingsPaymentDepositAccountPage";
